var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"richtext-block",class:[
       {'richtext-block--preview': _vm.preview},
       {'richtext-block--left-border': _vm.border_left},
       {'richtext-block--left-indent': _vm.left_indent}
     ]},[(_vm.label)?_c('label',{staticClass:"richtext-block__label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"richtext-block__content",domProps:{"innerHTML":_vm._s(_vm.format_source)}})])}
var staticRenderFns = []

export { render, staticRenderFns }